import { Button } from "@/ui-components/ui/button";
import { PageTitle, PageTitleContainer } from "@/ui-components/utils/menu-items/page-title";
import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import UsersFetchParent from "./fetcher";

const Users = () => {
  const [searchParams] = useSearchParams();
  const [searchQuery] = useState(searchParams.toString() || `page=1`);
  const [showInvitations, setShowInvitations] = useState(false);
  const [invitationCount, setInvitationCount] = useState(0);
  const [reload, setReload] = useState(false);

  return (
    <div>
      <PageTitleContainer>
        <div className="flex flex-row justify-between items-center">
          <PageTitle>Benutzer</PageTitle>
          <div className="flex gap-2 items-center">
            <Button onClick={() => setShowInvitations(!showInvitations)} variant="outline">
              {showInvitations
                ? "Benutzer anzeigen"
                : invitationCount + (invitationCount === 1 ? " Einladung" : " Einladungen") + " anzeigen"}
            </Button>
            <Link to={`/settings/users/create`}>
              <Button className="px-4 py-2 bg-blue-500 text-white rounded-md">+ Neuer Benutzer</Button>
            </Link>
          </div>
        </div>
      </PageTitleContainer>
      <UsersFetchParent
        searchQuery={searchQuery}
        setInvitationCount={setInvitationCount}
        setReload={setReload}
        reload={reload}
        showInvitations={showInvitations}
      />
    </div>
  );
};

export default Users;
